export class DealerFilter {

  page: number = 0;
  pageSize: number = 15;
  dealerName: string;
  dealerNumber: string;
  orderBy: string;
  order: string = 'ASC';
}


export class ReportFilter{
  page: number = 0;
  pageSize: number = 20;
  dealerNumber: string = null;
  orderBy: string ;
  order: string = 'ASC';
  invoicedDateFrom: Date;
  invoicedDateTo: Date;
  exportDateFrom: string;
  exportDateTo: Date;
}
